import React from "react";

const TemplateFooter = (props) => {
  return (
    <div className="footer d-flex">
      <button
        className="btn-tertiary cancel-button ml-auto"
        onClick={props.templateCloseHandler}
      >
        Cancel
      </button>
      {props.editTemplate ? (
        <>
        <button
            className="btn-tertiary draft-button"
            onClick={(event) => props.draftTemplateHandler(event)}
          >
            Save as draft
        </button>
        <button
          className="btn-primary mr-4"
          onClick={(event) => props.createTemplateHandler(event)}
          value="updateAll"
        >
          Save & update previous documents
        </button>
        <button
          className="btn-primary create-button"
          onClick={(event) => props.createTemplateHandler(event)}
        >
          Save changes for new documents
        </button>
        </>
      ) : (
        <>
          <button
            className="btn-tertiary draft-button"
            onClick={(event) => props.draftTemplateHandler(event)}
          >
            Save as draft
          </button>
          <button
            className="btn-primary create-button"
            onClick={(event) => props.createTemplateHandler(event)}
          >
            Create
          </button>
        </>
      )}
    </div>
  );
};

export default TemplateFooter;
